export default "__VITE_ASSET__a9e6fe55__"